const consents = [
    {
        name: 'consents[162]',
        text: '<span class="text-danger">*</span> Akceptuję <a target="_blank" href="https://www.wiosna.org.pl/regulamin-serwisu/">regulamin serwisu</a> szlachetnapaczka.pl oraz <a target="_blank" href="https://stripe.com/en-pl/legal/consumer">regulamin operatora płatności</a> Stripe.',
        required: true
    },
    {
        name: 'consents[163]',
        text: 'Chcę otrzymywać informacje marketingowe od Szlachetnej Paczki z wykorzystaniem mojego adresu e-mail. <a id="showDetails" href="#">Szczegóły></a>' +
                '<div id="details" class="d-none">Wyrażam zgodę na przetwarzanie moich danych osobowych w celach marketingowych, tj. otrzymywanie informacji o działaniach podejmowanych przez Stowarzyszenie WIOSNA (organizatora Szlachetnej Paczki) z wykorzystaniem mojego adresu e-mail. <a id="hideDetails" href="#">Zwiń</a></div>'
    }
]
export default consents
